import { clientFetch } from "@flights/client-fetch";
const report = (type, event) => {
    void clientFetch(`/events/${type}`, {
        method: "post",
        body: JSON.stringify(event),
        headers: {
            "Content-Type": "application/json",
            "X-Booking-Referrer": location.href || ""
        }
    });
};
export const grumble = (message, payload) => {
    report("grumble", { message, payload });
};
export const squeak = (message) => {
    report("squeak", { message });
};
export const warning = (message) => {
    report("warning", { message });
};
